import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '1rem',
  },
}));

export default useStyles;
